<!-- Clic délégué : les citations du manuel (`doc:…`) ouvrent l'article dans
     l'application au lieu de suivre leur adresse -->
<div class="flex flex-column gap-4" (click)="onClickThread($event)">
    @for (msg of messages; track $index) {
    @if (msg.role === 'user') {
    <div class="align-self-end border-round-2xl px-3 py-2 text-base bg-primary-100 text-primary-700">
        {{ msg.content }}
    </div>
    } @else {
    <!-- Raisonnement : ouvert et alimenté en direct, replié dès l'arrivée de la réponse -->
    @if (msg.reasoning) {
    <details class="ai-agent-reasoning w-full" [open]="!msg.content">
        <summary class="cursor-pointer text-sm text-color-secondary font-italic"><i class="bi bi-ai-sparkles-solo text-purple-800"></i> Réflexion…</summary>
        <markdown class="block text-sm text-color-secondary mt-1" [data]="msg.reasoning"></markdown>
    </details>
    }
    <!-- Journal des appels d'outils du tour (actions avant la réponse) : réservé à la supervision (présent dans le payload uniquement pour canViewMonitoring, §9.1) -->
    @if (msg.toolCalls?.length) {
    <details class="ai-agent-tools w-full">
        <summary class="cursor-pointer text-xs text-color-secondary"><i class="pi pi-wrench"></i> Appels d'outils ({{ msg.toolCalls!.length }})</summary>
        <div class="flex flex-column gap-2 mt-2">
            @for (call of msg.toolCalls; track $index) {
            <div class="border-1 border-round-lg border-200 surface-50 p-2 text-xs">
                <div class="flex align-items-center gap-2">
                    <span class="text-color-secondary">{{ call.roundIndex }}.{{ call.callIndex }}</span>
                    <span class="font-medium text-color">{{ call.toolName }}</span>
                    @if (call.resolvedToolName) {
                    <span class="text-color-secondary">→ {{ call.resolvedToolName }}</span>
                    }
                    <span class="flex-1"></span>
                    @if (call.success) {
                    <i class="pi pi-check-circle text-green-500"></i>
                    } @else {
                    <i class="pi pi-times-circle text-red-500"></i>
                    }
                </div>
                @if (call.error) {
                <div class="text-red-500 mt-1">{{ call.error }}</div>
                }
                <pre class="ai-agent-tools-args mt-1 mb-0">{{ call.arguments | json }}</pre>
            </div>
            }
        </div>
    </details>
    }
    @if (msg.content) {
    <markdown clipboard class="markdown-content block text-base text-color w-full" [data]="msg.content"></markdown>
    }
    <!-- Écritures et propositions de l'agent pendant le tour : une carte par action, avec ses boutons -->
    @for (action of msg.actions; track action.id) {
    <app-assistant-action-card [action]="action"></app-assistant-action-card>
    }
    <!-- Défaire tout ce que l'agent a fait pendant ce tour, tant qu'il en reste -->
    @if (canUndoTurn(msg)) {
    <div class="flex justify-content-end">
        <p-button label="Annuler cet échange" icon="fa-solid fa-rotate-left" size="small" severity="help" [text]="true"
            [rounded]="true" [loading]="pendingTurnIndex === msg.turnIndex" (onClick)="onClickUndoTurn(msg)"></p-button>
    </div>
    }
    @if (turnUndoReport && turnUndoReport.turnIndex === msg.turnIndex) {
    <app-message severity="warn" title="Ce qui n'a pas pu être annulé" [messages]="turnUndoReport.lines"></app-message>
    }
    <!-- Avis sur la réponse du tour : proposé une fois le flux terminé, quand le tour est enregistré -->
    @if (sessionId && msg.turnIndex !== undefined) {
    <app-assistant-feedback [sessionId]="sessionId" [turnIndex]="msg.turnIndex" [feedback]="msg.feedback ?? null"
        [feedbackComment]="msg.feedbackComment ?? ''" [readonly]="feedbackReadonly"
        (changed)="onChangeFeedback(msg, $event)"></app-assistant-feedback>
    }
    <!-- Consommation de ce tour : tokens + coût estimatif, ventilés -->
    @if (msg.usage && showUsage) {
    <app-assistant-usage [usage]="msg.usage"></app-assistant-usage>
    }
    }
    }

    <!-- Indicateur d'activité -->
    @if (statusText) {
    <div class="text-base text-color-secondary font-italic">{{ statusText }}<span class="assistant-dots"></span></div>
    }
</div>
